export enum HintType {
  PRESCRIPTION_FEE_EXEMPTION = 'PRESCRIPTION_FEE_EXEMPTION',
  FIXATION = 'FIXATION',
  FORM_NOT_FILLED = 'FORM_NOT_FILLED',
  FALL_ASSESSMENT = 'FALL_ASSESSMENT',
  FALL_RISK = 'FALL_RISK',
  CHRONIC_PAIN_DESCRIPTION = 'CHRONIC_PAIN_DESCRIPTION',
  PAINKILLER_EXISTS = 'PAINKILLER_EXISTS',
  CARE_PLAN = 'CARE_PLAN',
  CONSULTATION = 'CONSULTATION',
  MOVEMENT_STATUS = 'MOVEMENT_STATUS',
  DECUBITUS_RISK = 'DECUBITUS_RISK',
  HOSPITAL_EXPORT = 'HOSPITAL_EXPORT',
  NURSE_VISIT = 'NURSE_VISIT',
  ABWEICHENDER_PFLEGEGRAD = 'ABWEICHENDER_PFLEGEGRAD',
  // FIXME: Execution hints are temporarily disabled
  // EXECUTION_MISSING = 'EXECUTION_MISSING',
}
